import Link from "next/link";
import {
    FACEBOOK_PAGE_URL,
} from "@rosette/ts/src/business/constants.js";
import Image from "next/image";
import facebookIcon from "@rosette/assets/src/icons/facebook.svg";
import { Panel } from "@rosette/web_components/src/ui/Panel.js";


interface SmallSocialLinksProps {
    className?: string;
}


export function SmallSocialLinks({ className }: SmallSocialLinksProps) {
    return (
        <Panel size="sm" className={className}>
            <Link className="flex flex-row flex-wrap items-center justify-start gap-3" href={FACEBOOK_PAGE_URL}>
                <div className="leading-0 w-[2.6em] [&_img]:w-[2.6em]">
                    <Image
                        src={facebookIcon}
                        alt="Facebook"
                        width="48"
                        height="48" />
                </div>

                <p className="mt-1 mx-0 mb-0">
                    Like our page on Facebook
                </p>
            </Link>
        </Panel>
    );
}
